import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { Table } from "@/shared/ui/table"
import { ColumnDef } from "@tanstack/react-table"
import { Pagination } from "@/shared/ui/pagination"
import { IPrize, PrizeStatus } from "@/shared/api/marketing-campaigns/types"
import { selectBonuses } from "@/entities/bonus"
import { Link } from "react-router-dom"
import { selectPrizes, selectPrizesLoading, selectPrizesPage, selectPrizesTotalPages, setPrizesPage } from "@/entities/marketing-campaign"
import { getDisplayName } from "@/entities/user"

const prizeStatusNames: Record<PrizeStatus, string> = {
    "error": "Ошибка при начислении",
    "waiting": "Ожидает начисления",
    "success": "Бонусы начислены"
}

export const PrizesTable = () => {
    const prizes = useAppSelector(selectPrizes)
    const isLoading = useAppSelector(selectPrizesLoading)
    const dispatch = useAppDispatch()
    const page = useAppSelector(selectPrizesPage)
    const totalPages = useAppSelector(selectPrizesTotalPages)
    const bonuses = useAppSelector(selectBonuses)

    const columns: ColumnDef<IPrize, any>[] = [
        {
            accessorFn: (prize) => (
                <div className="w-full">
                    {prize.place}
                </div>
            ),
            id: 'place',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Место</div>,
        },
        {
            accessorFn: (prize) => prize,
            id: 'bonusid',
            enableSorting: false,
            cell: info => {
                const prize: IPrize = info.getValue()
                return (
                    <div className="flex gap-2 items-center">
                        <div className="w-10 h-10 rounded-full overflow-hidden">
                            <img src={bonuses.find(b => b.id === prize.bonus_id)?.image} className="w-full h-full object-contain" alt="" />
                        </div>
                        <div>
                            {prize.amount}
                        </div>
                    </div>
                )
            },
            header: () => <div className="!text-start text-nowrap">Награда</div>,
        },
        {
            accessorFn: (prize) => (
                <div>
                    {prize.user
                        ? <Link className="hover:cursor-pointer hover:underline text-color-primary font-semibold" to={`/users/profile/${prize.user.id}`}>{prize.user.name || prize.user.telegram_id}</Link>
                        : "—"
                    }
                </div>
            ),
            id: 'user',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Победитель</div>,
        },
        {
            accessorFn: (prize) => (
                <div>
                    {prizeStatusNames[prize.status] || "—"}
                </div>
            ),
            id: 'startDate',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Статус</div>,
        },
    ]

    return (
        <>
            {Boolean(prizes.length) &&
                <div className="table_box">
                    <div className="font-mediumttf text-xl px-2 py-2">
                        Призовые места
                    </div>
                    <Table columns={columns} data={prizes} />
                    <Pagination 
                        page={page} 
                        totalPages={totalPages} 
                        setPage={(page) => dispatch(setPrizesPage(page))}
                    />
                </div>
            }
            {(!Boolean(prizes.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(prizes.length) && !isLoading) &&
                <NoTableData label="Нет данных о кампаниях" />
            }
        </>
    )
}